import { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { ASSET_HOST_BASE_URL, otherParty } from "../../../../config";
import LangContext from "../../../../contexts/LangContext";
import { translate, translateNumber } from "../../../../helper";
import { LoaderCard } from "../../../common/Loader";
import "./index.css";

const TopPartiesSeatChart = (props) => {
  const { lang } = useContext(LangContext);

  useEffect(() => {
    const chartData = JSON.parse(JSON.stringify(props.chartData));
    if (props.fetched) {
      plotChart(chartData);
    }
  }, [props]);

  const plotChart = (chartData) => {
    const gw = chartData
      .sort((x, y) => y.win - x.win)
      .map((gwin) => {
        const partyDetail = props.parties.find((par) => par.code === gwin.party) || otherParty;
        let data = [partyDetail["short_name_" + lang] || partyDetail["name_" + lang], gwin.win, translateNumber(gwin.win, lang), partyDetail.color, partyDetail["short_name_" + lang] || partyDetail["name_" + lang]];
        // let leadParty = chartData.lead.find((glead) => glead.party === gwin.party);
        // data[1] = data[1] + (leadParty ? leadParty.lead : 0);
        return data;
      });

    new window.Highcharts.chart({
      chart: {
        type: "item",
        renderTo: "global-all-parties",
      },
      title: {
        text: "",
      },
      legend: {
        labelFormat: '{name} <span style="opacity: 0.4">{x}</span>',
        itemMarginTop: 5,
        itemMarginBottom: 5,
        itemStyle: {
          fontSize: "14px",
        },
        // padding: 10,
      },
      tooltip: {
        pointFormat: '<span style="color:{point.color}">{series.name}</span>: <b>{point.x}</b><br/>',
      },
      series: [
        {
          name: translate("seat", lang),
          keys: ["name", "y", "x", "color", "label"],
          data: gw,
          dataLabels: {
            enabled: true,
            format: "{point.label}",
            style: {
              fontSize: "15px",
              padding: "5px",
            },
          },

          // Circular options
          center: ["50%", "90%"],
          size: "170%",
          startAngle: -90,
          endAngle: 90,
          innerSize: "30%",
        },
      ],

      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 600,
            },
            chartOptions: {
              series: [
                {
                  dataLabels: {
                    distance: -30,
                    style: {
                      fontSize: "15px",
                      padding: "5px",
                    },
                  },
                },
              ],
            },
          },
        ],
      },
      credits: {
        enabled: false,
      },
    });
  };

  return (
    <div className="sh-show-later container-fluid card sh-card-chart">
      {!props.fetched && <LoaderCard />}
      <div className="row" style={{ opacity: props.fetched ? "1" : 0.5 }}>
        <div className="col-md-12 sh-chart">
          <h2 className="text-center">{translate("major_parties", lang)}</h2>
          <div className="row sh-chart-pie">
            <div className="col-sm-12">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="box">
                    <div id="global-all-parties" className="hidden-xs"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopPartiesSeatChart;
